/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import ActionsMenuBig from '../../components/shared/ActionsMenuBig'
import { useFsiActionMenu } from '../../hooks/useFsiActionMenu'

interface PageMenuProps {
  fsi: any
  options?: any
}

export const PageMenu: React.FC<PageMenuProps> = ({ fsi, options = {} }) => {
  const { items, setIsOpen } = useFsiActionMenu(fsi, options)

  return (
    <div>
      <ActionsMenuBig
        menuId="page"
        onToggle={(open: boolean) => {
          setIsOpen(open)
        }}
        items={items}
      />
    </div>
  )
}
